export default "__VITE_ASSET__Blfs0u6A__"